import React from "react";
import { Dialog,  DialogContent, DialogActions, Typography, LinearProgress } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';


const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    borderBottom: '1px solid #dad6d6',
    // backgroundColor: 'red',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",
    "& .MuiButton-root": {
      // backgroundColor: 'red'
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
}));

function AddNewItem(props) {  
  const { title } = props
  const classes = useStyles();

  const onClose = () => {
    props.onClose(false);
  };

  return (
    <Dialog
        open={props.open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
      <DialogTitle id="alert-dialog-title" onClose={onClose}>{title || "Create New Item" }</DialogTitle>
      {props.isLoading && <LinearProgress />}
        <DialogContent>
          {props.children}
        </DialogContent>
        <DialogActions className={classes.DialogActions}>
          {props.actions}
        </DialogActions>
      </Dialog>
  )
}

export default AddNewItem;